import { createFileRoute } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { getModality } from '@/components/temas/modalities';
import { ThemeThumbnail } from '@/components/temas/ThemeThumbnail';

export const Route = createFileRoute('/_admin/temas/preview/$code')({
  component: ThemePreviewPage,
});

interface ThemeRow {
  id: string;
  theme_assets?: Record<string, string> | null;
  themeAssets?: Record<string, string> | null;
  background_color?: string | null;
  backgroundColor?: string | null;
  modality_code?: string | null;
  modalityCode?: string | null;
}

function normalize(row: any): ThemeRow | null {
  if (!row) return null;
  const rawAssets = row.themeAssets ?? row.theme_assets;
  let themeAssets: Record<string, string> | null = null;
  if (rawAssets && typeof rawAssets === 'object') {
    themeAssets = rawAssets as Record<string, string>;
  } else if (typeof rawAssets === 'string' && rawAssets.length > 0) {
    try {
      themeAssets = JSON.parse(rawAssets);
    } catch {
      themeAssets = null;
    }
  }
  return {
    id: row.id,
    theme_assets: themeAssets,
    background_color: row.backgroundColor ?? row.background_color ?? null,
  };
}

function ThemePreviewPage() {
  const { code } = Route.useParams();
  const search = Route.useSearch() as Record<string, string>;
  const themeId = search.theme_id;
  const modality = getModality(code);

  // Listen for real-time asset updates via postMessage (from editor iframe)
  const [overrideAssets, setOverrideAssets] = useState<Record<string, string>>({});
  useEffect(() => {
    const handler = (event: MessageEvent) => {
      if (event.data?.type === 'theme-assets-update' && event.data.assets) {
        setOverrideAssets(event.data.assets);
      }
    };
    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }, []);

  const { data: theme } = useQuery<ThemeRow | null>({
    queryKey: ['theme-preview', themeId],
    queryFn: async () => {
      if (!themeId) return null;
      const res = await api.get('/admin/game-themes');
      const raw = res.data?.themes ?? res.data?.data ?? res.data ?? [];
      const list = Array.isArray(raw) ? raw : [];
      const found = list.find((t: any) => t.id === themeId);
      return normalize(found);
    },
    enabled: !!themeId,
  });

  if (!modality) {
    return (
      <div
        style={{
          width: '100vw',
          height: '100vh',
          background: '#0a0a0f',
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: 'system-ui, sans-serif',
        }}
      >
        <div className="text-center">
          <p className="text-sm opacity-70">Modalidade desconhecida</p>
          <code className="text-xs opacity-60 mt-2 block">{code}</code>
        </div>
      </div>
    );
  }

  const dbAssets = theme?.theme_assets ?? {};
  const assets = { ...dbAssets, ...overrideAssets };
  const bgColor = assets.background_color || theme?.background_color || '#0a0a0f';

  return (
    <div
      style={{
        width: '390px',
        height: '700px',
        overflow: 'hidden',
        background: bgColor,
        fontFamily: 'system-ui, sans-serif',
      }}
    >
      <ThemeThumbnail modality={modality} assets={assets} />
    </div>
  );
}
